import React, { useState,useRef,useEffect } from 'react'
import { CButton, CCard, CCardBody, CCol, CForm, CInputGroup, CRow } from '@coreui/react'

import CIcon from '@coreui/icons-react'
import { cilChevronBottom, cilChevronTop } from '@coreui/icons'
import BaseListing from 'src/BaseListings'
import { wtApiCall } from 'src/helpers/commons/ApiWrapper'
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useDownloadExcel } from 'react-export-table-to-excel'

import Loading from 'src/helpers/commons/loader'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import { wtRoundValue } from 'src/helpers/commons/utils'
export default function VehicleTrackingDetailsReportDataTable() {
  const Base = new BaseListing()
  const [isLoading, setIsLoading] = useState(false)
  const [sortedKey, setSortedKey] = useState('')
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' })
  const location = useLocation();
  const tableRef = useRef(null)

  const { deviceId, from_date, to_date } = queryString.parse(location.search);
  const [reportData, setReportData] = useState([])
  console.log(reportData.registration)

  const sortTable = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    const sorted = [...reportData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'asc' ? -1 : 1
      }
      if (a[key] > b[key]) {
        return direction === 'asc' ? 1 : -1
      }
      return 0
    })
    setReportData(sorted)
    setSortedKey(key)
    setSortConfig({ key, direction })
  }
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'Vehicle Tracking Report',
    sheet: 'Sheet',
  })
  const getReportData = (deviceId) => {
    setIsLoading(true)
    wtApiCall(
      'reports/vehicle_tracking_details_report/',
      {
        device_id: deviceId,
        from_date: from_date,
        to_date: to_date,

      },
      'get',
      (response) => {
        setReportData(response.data)
        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
        setIsLoading(false)
      },
    )
  }
  useEffect(() => {
    getReportData(deviceId)
  }, [])

  const getTotalMilage = () => {
    let total = 0;
    reportData.map((item) => total += parseFloat(item.milage))

    return total
  }
  return (

    <>
        <div style={{ padding: '2%' }}>
        <center>
          <h4>Vehicle Tracking Detail Report</h4>
        </center>
      </div>
      
      <div style={{ padding:'0% 2.5%',display: 'flex', justifyContent: 'space-between' }}>
        <div>
        <span style={{ fontWeight:'bold'}}>Device ID: <span style={{color:'blue' , marginRight:'30px'}}>{deviceId}</span> Registration NO : <span style={{ color: 'blue' }}>
  
        {reportData[0]?.registration || 'Loading...'}</span> </span> 
        </div>
           <div>
           {Base.hasRights('Export Vehicle Tracking Report') && (
               <CButton
                 color="success"
                 className="text-white"
                 style={{ marginBottom: '10px', marginTop: '0px', marginLeft: '1%'}}
                 onClick={onDownload}
               >
                 Export
               </CButton>
               )} 
           </div>
      </div>
      <table style={{ width: '95%', margin: 'auto' }} className="table table-bordered data-table" ref={tableRef}>
        {isLoading ? (
          Loading
        ) : (
          <>
            <thead className="thead-dark border-dark border-1 " style={{ backgroundColor: '#e8e9eb' }}>
              <tr>
                <th onClick={() => sortTable('id')}>Sr</th>
                <th>
                  Date
                  {sortedKey === 'date' && (
                    <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                  )}
                </th>
                <th>
                  Milage
                  {sortedKey === 'milage' && (
                    <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                  )}
                </th>
              </tr>
            </thead>
          </>
        )}
        <tbody>

          {reportData.map((item, index) => {
            return (
              <tr key={index}>
                <td className='border-1'>{index + 1}</td>
                <td className='border-1'>{item.date}</td>
                <td className='border-1'>{wtRoundValue(item.milage, 2)}</td>
              </tr>
            );
          })}

        </tbody>
        <tfoot>
          <tr>
            <th colSpan={2} style={{ textAlign: 'center' }}>Total</th>
            <th>{wtRoundValue(getTotalMilage(), 2)} KM</th>
          </tr>
        </tfoot>
      </table>

    </>
  )
}
